<template>
  <div class="row padd-0" v-if="Object.keys(cust).length > 0">
    <div class="col-12 padd-0">
      <div
        :class="['row', mode == 'sent' ? 'sentElStyle' : 'unsentElStyle']"
        v-b-toggle="mode == 'sent' ? colpId : ''"
        :style="mode == 'sent' ? 'cursor: pointer;' : ''"
        v-if="Object.keys(cust).length > 0"
      >
        <div class="col-1">{{cust.id}}</div>
        <div class="col-2">{{cust.name}}</div>
        <div class="col-2" v-if="mode != 'sent'">{{cust.vehInfo}}({{cust.vehId}})</div>

        <div class="col-2" v-if="mode != 'sent'">
          <b-button
            class="select-flp-status select-flp-color-red"
            variant="outline-primary"
            @click="AddPhoneModal()"
            v-if="cust.phones.length == 1 && cust.phone == 'Add Phone'"
          >Add Phone</b-button>
          <b-form-select
            v-model="cust.phone"
            :options="cust.phones"
            :class="['mb-3', 'select-flp-status', cust.display.phonestyle]"
            @change="SetPhone()"
            v-if="!(cust.phones.length == 1 && cust.phone == 'Add Phone')"
          ></b-form-select>
        </div>

        <div class="col-2" v-if="mode != 'sent'">
          <b-form-select
            v-model="cust.status"
            :options="flpStatusOptions"
            :class="['mb-3', 'select-flp-status', cust.display.statusstyle]"
            @change="ChangeStatus()"
          ></b-form-select>
        </div>
        <div class="col-2" v-if="mode == 'sent'">{{cust.phone}}</div>
        <div class="col-2" v-if="mode == 'sent'">
          <b-form-checkbox v-model="cust.reply_received" disabled></b-form-checkbox>
        </div>
        <div
          class="col-2"
          v-if="mode == 'sent'"
        >{{cust.flps[0].status}} on {{cust.flps[0].status == 'sent' ? mstTime(cust.flps[0].sent_time) : ''}}</div>
        <div class="col-2" v-if="mode == 'sent' && cust.sent_time_num_2 == -1">Was not sent</div>
        <div
          class="col-2"
          v-if="mode == 'sent' && cust.sent_time_num_2 != -1"
        >{{cust.flps[1].status}} on {{cust.flps[1].status == 'sent' ? mstTime(cust.flps[1].sent_time) : ''}}</div>
        <div class="col-2" v-if="mode != 'sent'">{{mstTime(cust.scheduled_time)}}</div>
        <div class="col-1">{{cust.evtype}}</div>
      </div>

      <b-collapse :id="colpId" v-if="mode == 'sent'">
        <div class="row sent-collapse-style">
          <div class="col-12">
            <div class="row">
              <div class="col-3 m-color" style="font-weight: bold">
                <p class="padd-0 mb--0">First touch message sent:</p>
                <p class="padd-0 collapse-msg-date-style mb--0">{{mstTime(cust.flps[0].sent_time)}}</p>
              </div>
              <div class="col-7">{{cust.flps[0].sent_msg}}</div>
              <div class="col-2" v-if="cust.reply_received">
                <b-button variant="outline-primary" v-b-modal.viewChatFlp>View Chat</b-button>
              </div>
            </div>
            <div class="row" style="margin-top:14px;" v-if="cust.sent_time_num_2 == -1">
              <div class="col-3 m-color" style="font-weight: bold">
                <p class="padd-0 mb--0">Second message was not sent</p>
              </div>
            </div>
            <div class="row" style="margin-top:14px;" v-if="cust.sent_time_num_2 != -1">
              <div class="col-3 m-color" style="font-weight: bold">
                <p class="padd-0 mb--0">Second message sent:</p>
                <p class="padd-0 collapse-msg-date-style mb--0">{{mstTime(cust.flps[1].sent_time)}}</p>
              </div>
              <div class="col-7">{{cust.flps[1].sent_msg}}</div>
            </div>
            <!-- <div class="row" v-if="cust.reply_received" style="margin-top:14px;">
              <div class="col-2 m-color" style="font-weight: bold">
                <p class="padd-0 mb--0">Customer replied:</p>
                <p
                  class="padd-0 collapse-msg-date-style mb--0"
                >{{FormatDateToMMDDTT(cust.cust_reply.sendDate)}}</p>
              </div>
              <div class="col-8">{{cust.cust_reply.msg}}</div>
            </div>-->
          </div>
        </div>
      </b-collapse>

      <b-modal
        id="modal-addphone"
        title="Add phone Number"
        ref="modal-addphone"
        ok-only
        @ok="AddPhoneProcess()"
      >
        <p class="my-4">Please, enter phone number for {{cust.name}} (#{{cust.id}})</p>
        <b-form-input id="addphone-input" v-model="addedPhone" required placeholder="Enter phone"></b-form-input>
      </b-modal>

      <b-modal
        id="viewChatFlp"
        :title="'Conversation with ' + cust.name + ' (Cust-No: ' + cust.id + ')'"
        size="xl"
        centered
        hide-footer
      >
        <viewChatWindow :ssId="cust.reply_ssId" :colId="colpId" />
      </b-modal>
    </div>
  </div>
</template>

<script>
import viewChatWindow from "./../additionalComponents/viewChatWindow.vue";

export default {
  name: "customerRow",
  components: {
    viewChatWindow
  },
  props: {
    value: Object,
    mode: String,
    colpId: String
  },
  data() {
    return {
      cust: {},
      addedPhone: "",
      flpStatusOptions: [
        { value: "contacted", text: "Contacted" },
        { value: "scheduled", text: "Scheduled" },
        { value: "cancelled", text: "Cancelled" },
        { value: "paused", text: "Paused" },
        { value: "review", text: "Review" },
        { value: "sent", text: "Sent", disabled: true }
      ]
    };
  },

  watch: {
    value: function() {
      this.SetAndCheck();
    }
  },

  mounted() {
    this.SetAndCheck();
  },

  methods: {
    SetAndCheck() {
      this.cust = Object.assign({}, this.cust, this.value);
      this.CheckValidData();
    },
    CheckValidData() {
      this.cust["display"] = {
        phonestyle: "select-flp-color-std",
        statusstyle: "select-flp-color-std"
      };

      if (!this.cust.phones || this.cust.phones == null) {
        this.cust.phones = [];
      }

      for (let px in this.cust.phones) {
        if (this.cust.phones[px] == "") {
          this.cust.phones.splice(px, 1);
        }
      }

      if (!this.cust.phone || this.cust.phone == null) {
        this.cust.phone = "";
      }

      if (this.cust.phones.indexOf("Add Phone") < 0) {
        this.cust.phones.push("Add Phone");
      }

      if (!this.cust.phone) {
        if (this.cust.phones.length >= 1) {
          this.cust.phones.unshift("Select Phone");
        }

        this.cust.display.phonestyle = "select-flp-color-red";
        this.cust.status = "review";
        this.cust.phone = this.cust.phones[0];
      }

      this.cust.display.statusstyle =
        this.cust.status == "scheduled" ||
        this.cust.status == "sent" ||
        this.cust.status == "contacted"
          ? "select-flp-color-green"
          : this.cust.status == "review"
          ? "select-flp-color-red"
          : "select-flp-color-std";
    },
    SetPhone() {
      if (this.cust.phone == "Add Phone") {
        this.AddPhoneModal(this.cust);
      } else if (this.cust.phone != "Select Phone") {
        let ix = this.cust.phones.findIndex(el => el == "Select Phone");
        if (ix >= 0) {
          this.cust.phones.splice(ix, 1);
        }
        let iy = this.cust.phones.findIndex(el => el == "Add Phone");
        if (iy >= 0) {
          this.cust.phones.splice(iy, 1);
        }

        this.cust.status = "scheduled";

        this.$emit("applyChanges", {
          ref: `followup/{{loc}}/${this.cust.ssId}`,
          value: {
            phone: this.cust.phone,
            status: this.cust.status
          }
        });
      }
    },

    ChangeStatus() {
      this.$emit("applyChanges", {
        ref: `followup/{{loc}}/${this.cust.ssId}`,
        value: {
          status: this.cust.status
        }
      });
    },

    AddPhoneModal() {
      if (this.cust != undefined && this.cust.ssId != undefined) {
        this.addedPhone = "";

        this.$refs["modal-addphone"].show();
      }
    },

    AddPhoneProcess() {
      this.cust.phones = this.cust.phones.filter(
        el => el != "Add Phone" && "Select Phone"
      );

      this.cust.phone = this.addedPhone;
      this.cust.phones.push(this.addedPhone);
      this.$emit("applyChanges", {
        ref: `followup/{{loc}}/${this.cust.ssId}`,
        value: {
          phones: this.cust.phones
        }
      });

      this.SetPhone();
    },

    mstTime(t) {
      return t
        ? new Date(t).toLocaleString("en-US", {
            timeZone: "America/Edmonton",
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit"
          })
        : "";
    }
  }
};
</script>
<style scoped>
.padd-0 {
  padding: 0;
}
.m-color {
  color: #266db3;
}

.select-flp-status {
  padding: 0;
  margin-left: 25px;
  padding-right: 25px;
  padding-left: 15px;
  margin-bottom: 0 !important;
  background: transparent;
  border: 1px solid;
  height: auto;
  max-width: max-content;
}

.select-flp-color-green {
  color: green;
  border-color: #0064002e;
}

.select-flp-color-std {
  color: rgb(30, 56, 97);

  border-color: #0064002e;
}

.select-flp-color-red {
  color: firebrick;
  border-color: firebrick;
}

.unsentElStyle {
  padding-top: 10px;
  color: rgb(30, 56, 97);

  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #d2e8e357;
  border-radius: 0.5em;
}

.sentElStyle {
  padding-top: 10px;
  color: rgb(30, 56, 97);
  /* font-weight: bold; */
  margin-top: 10px;
  /* margin-bottom: 10px; */
  background-color: #d2e8e357;
  border-radius: 0.5em;
}

.sent-collapse-style {
  padding-top: 20px;
  color: rgb(30, 56, 97);
  text-align: left;
  padding-bottom: 20px;
  border: 1px solid #d2e8e357;
}

.collapse-msg-date-style {
  font-weight: 100;
  font-size: 12px;
}

.mb--0 {
  margin-bottom: 0;
}
</style>




